/**
 * @generated SignedSource<<cd5bf82e177b890f5d764dbae93d1018>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarFavorites_item$data = {
  readonly serviceId: string | null;
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item" | "FavoritesItemProvider_item">;
  readonly " $fragmentType": "PdpSharedSidebarFavorites_item";
};
export type PdpSharedSidebarFavorites_item$key = {
  readonly " $data"?: PdpSharedSidebarFavorites_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarFavorites_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "41708598136f42483f812c72c85944a2";

export default node;
